<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Edit Worker's Sites</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div *ngIf="newSites.length">
        <p><b>Add worker to sites:</b></p>
        <p *ngFor="let site of newSites">{{site.name}}</p>
      </div>
      <div *ngIf="editSites.length">
        <p><b>Editing on sites:</b></p>
        <p *ngFor="let site of editSites">{{site.name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-12">
            <button *ngIf="!!copiedOptions" type="button" class="btn btn-link float-right" (click)="pasteValues()">Paste</button>
          </div>
          <div class="col-md-12" *ngIf="siteTypeAssetCategories.length">
            <div class="form-group">
              <label>Categories <span class="required-star">*</span></label>
              <p-multiSelect
                  class="form-control"
                  formControlName="assetCategories"
                  [options]="siteTypeAssetCategories"
                  optionLabel="label"
                  defaultLabel="Select Categories"
                  [style]="{ width: '100%' }"
              >
              </p-multiSelect>
              <div *ngIf="form.get('assetCategories').value && form.get('assetCategories').value.length > 0">
                <div *ngFor="let item of form.get('assetCategories').value" class="badge badge-pill badge-success" [ngStyle]="{ 'background-color': item.color }">
                  {{ item.label }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group form-group-checkbox">
              <label>Guests Permitted?</label>
              <p-checkbox class="form-control" formControlName="guestsPermitted" binary="true"></p-checkbox>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group form-group-checkbox">
              <label>Site Session Permitted?</label>
              <p-checkbox class="form-control" formControlName="managementDuty" binary="true"></p-checkbox>
            </div>
          </div>
        </div>
      </form>
    </div>
    <br>
    <div class="col-md-12">
      <p-footer>
        <button type="button" (click)="onSubmit()" [disabled]="saveInProgress || !form.valid" class="btn btn-sm btn-success">Save</button>
        <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
      </p-footer>
    </div>
  </div>
</div>
